import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/ContactDetails/ContactDetails.js
const ContactDetails = createSectionForm({
  icon: "phone-line",
  title: "Contact Details",
  fields: [
    { name: "title", label: "Title" },
    { name: "sales_heading", label: "Sales Heading", placeholder: "Advice, Sales & Support" },
    { name: "sales_toll_free", label: "Sales Toll Free Number" },
    { name: "sales_toll_free_tel", label: "Sales Toll Free Link", placeholder: "tel:+18556366287" },
    { name: "sales_local", label: "Sales US Local Number" },
    { name: "sales_local_tel", label: "Sales US Local Link", placeholder: "tel:+14079775100" },
    { name: "button_text", label: "Button Text" },
    { name: "button_link", label: "Button Link", type: "link" },
    { name: "wholesale_heading", label: "Wholesale Heading", placeholder: "Wholesale" },
    { name: "wholesale_toll_free", label: "Wholesale Toll Free Number" },
    {
      name: "wholesale_toll_free_tel",
      label: "Wholesale Toll Free Link",
      placeholder: "tel:+18008364858",
    },
  ],
});

export default ContactDetails;
